module.exports = __webpack_public_path__ + "static/media/laws.6c96b7f2.svg";